

import $axios from '@/utils/axios'

var host = process.env.NODE_API_HOST

export default {
    /**
     * 测试接口
     * 地址：/test/a
     */
    get(data = {}) {
        return $axios.get({
            url: `${host}/test/a`,
            data
        })
    },
    post(data = {}) {
        return $axios({
            method: 'post',
            url: `${host}/h5/saveOrUpdateExamScore`,
            data
        })
    },
}